module.exports = __webpack_public_path__ + "img/remove_shopping_cart_orange.0c34c78f.svg";